// When working with React states, sorting arrays in-place (i.e. what Array.prototype.sort() does)
// is not necessarily desired behaviour. States should not be manipulated directly.
export const sortNotInPlace = <T extends unknown>(
  array: T[],
  callback: (a: T, b: T) => number,
): T[] => [...array].sort(callback);
